<template>
  <multiple-cascader
    ref="cascader"
    v-model="filters"
    :min="0"
    add-text="Ajouter un filtre"
    :props="dimensionProps"
    :load-children="dimensionLoad"
    :title="i => 'Filtre ' + i"
    :options="dimensions"
    :createNew="createNewFilter"
    :value-options="filterOptions"
    @input="() => emit()" >
    <template slot="more" slot-scope="{data, internal, i}" >
      <el-form-item class="default-filter" >
        <component
          v-if="data.options.type && data.value"
          :is="data.options.type + '-filter'"
          :class="data.options.type + '-filter'"
          :data="data"
          placeholder="valeur par défaut"
          @change="val => setDefaultFilter(data, i, val)" />
      </el-form-item>
      <el-form-item>
        <el-radio-group
          v-model="internal.state"
          @change="val => setDisplayState(internal, i, val)" >
          <el-radio label="editable" >Modifiable</el-radio>
          <el-radio label="disabled" >Non modifiable</el-radio>
          <el-radio label="private" >Privé</el-radio>
          <el-radio label="hidden" >Caché</el-radio>
        </el-radio-group>
      </el-form-item>
    </template>
  </multiple-cascader>
</template>

<script>
import MultipleCascader from '../MultipleCascader'
import customGraphApiAware from '../mixins/customGraphApiAware'
import * as filters from '../filter'
import api from '../api'

export default {
  components: {
    MultipleCascader,
    ...filters
  },
  mixins: [
    customGraphApiAware
  ],
  props: {
    value: {
      type: Array,
      required: true
    },
    dimensions: {
      type: [Array, Object],
      default: () => []
    }
  },
  watch: {
    value: {
      handler () {
        if (!this.equals(this.filters, this.value)) {
          this.filters.splice(0, this.filters.length, ...this.value)
        }
      },
      immediate: true
    },
    dimensions: {
      handler () {
        if (this.$refs.cascader) {
          this.$refs.cascader.updateData()
        }
      },
      immediate: true
    }
  },
  data () {
    return {
      filters: [],
      dimensionProps: {
        label: api.dimension.props.name,
        value: api.dimension.props.uniqueName,
        children: 'children',
        disabled: 'disabled'
      },
      filterOptions: [
        {
          key: 'type',
          options: [
            {key: 'single-select', label: 'Liste de sélection'},
            {key: 'select', label: 'Liste de sélection multiple'},
            {key: 'range', label: 'Plage de donnée'},
            {key: 'hierarchy', label: 'Hiérarchie'}
          ]
        }
      ]
    }
  },
  methods: {
    createNewFilter () {
      return {
        defaultValues: [],
        state: 'editable'
      }
    },
    dimensionLoad (dimension) {
      this.$store.dispatch('customGraph/loadDimension', this.api.dimension.uniqueName(dimension))
    },
    setDefaultFilter (data, i, val) {
      data.defaultValues.splice(0, data.defaultValues.length, ...val.values)
      this.emit()
    },
    setDisplayState (data, i, val) {
      this.filters[i].state = val
      this.emit()
    },
    equals (a, b) {
      if (a.length !== b.length) {
        return false
      }
      for (let i = 0; i < a.length; ++i) {
        if (a[i] !== b[i]) {
          return false
        }
      }
      return true
    },
    emit () {
      this.$emit('input', this.filters)
    }
  }
}
</script>



// WEBPACK FOOTER //
// node_modules/macarons-graphs-front/src/components/FiltersEditor.vue